import React from 'react';
import { withStyles, makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

function createData(user, purpose, amount, printcharge) {
  user = user.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  purpose = purpose.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  amount = amount.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  printcharge = printcharge.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  return {user, purpose, amount, printcharge};
}

const amountRows = [
  createData('内部編集、自費出版･展示', '雑誌･書籍･パンフレット･¥nホームページ等での記事、写真使用', '3,300円¥n（税込み）', 'Ａ４：1,100円（税込み）¥n２L：330円（税込み）'),
  createData('編集委託、営利出版･展示', '雑誌･書籍･パンフレット･¥nホームページ等での記事、写真使用', '5,500円¥n（税込み）', 'Ａ４：2,200円（税込み）¥n２L：660円（税込み）'),
  createData('放送局、新聞社等', 'テレビ番組、紙面等での記事、写真使用', '11,000円¥n（税込み）', 'Ａ４：3,300円（税込み）¥n２L：1,100円（税込み）'),
  createData('放送局、新聞社等', '動画使用', '55,000円¥n（税込み）', ''),
];

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function DailyRight() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            著作権について
          </Typography>
          　デーリー東北(本紙、ホームページ)に掲載された記事、写真、動画、イラストなどの著作権は、デーリー東北新聞社および配信した通信社など各情報提供者にあります。無断転載、再配信等は固くお断りします。<br/>
          　著作権については、日本新聞協会の見解に準拠します。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="http://www.pressnet.or.jp/statement/copyright/" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  ネットワーク上の著作権について<br/>（日本新聞協会の見解）
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            著作物の二次利用について
          </Typography>
          　デーリー東北(本紙、ホームページ)に掲載された記事、写真、動画、イラスト、または当社が発行した刊行物等の著作物を利用する場合は、デーリー東北新聞社の許諾が必要です。利用する場合は、原則として有料です。ご希望の方は、｢著作物使用許可申請書｣に必要事項を記入して、メール＝kouhou@daily-tohoku.co.jp＝またはファクス＝0178(47)0841＝、郵送で申し込んでください。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                {/* <CustomButton href="pdf/tyosakuriyou-202206.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  著作物使用許可申請書
                </CustomButton> */}
                <CustomButton href="zip/tyosakuriyou-202304.zip" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  著作物使用許可申請書
                </CustomButton>
                ※クリックするとWordファイルとPDFファイルがダウンロードできます
              </Grid>
            </Grid>
          </Box>
          <dl>
            <dt>対象となる著作物</dt>
            <dd>
              　利用できる著作物は、デーリー東北新聞社に著作権があるものに限ります。共同通信などの配信記事、写真等は提供できません。<br/>
              　また、コラムなどの依頼原稿、読者の寄稿など社外の執筆者による著作物については、申請者が著作権所有者の許諾を得る必要があります。<br/>
            </dd>
            <dt>許諾しないケース</dt>
            <dd>
              <ol>
                <li>報道の自由を侵害したり、デーリー東北新聞社の信用や品位を傷つける恐れがある場合。</li>
                <li>選挙運動や布教目的、訴訟目的、誹謗中傷に使われる恐れがある場合。</li>
                <li>著作権や肖像権を侵害する恐れがある場合、個人・団体の名誉やプライバシーを侵害する恐れがある場合。</li>
                <li>テレビ放送の三次利用につながるインターネット配信。</li>
                <li>新聞製本や写真ネガおよびデータでの提供。</li>
                <li>申請者に過去に違反があった場合。</li>
                <li>その他、当社が不適当と判断した場合。</li>
              </ol>
            </dd>
            <dt>許諾要件</dt>
            <dd>
              <ol>
                <li>利用は１申請につき1回限りとし、申請目的以外の利用、他への転用は認めません。</li>
                <li>｢デーリー東北新聞社提供｣｢紙面掲載日｣の出所を明記してください。</li>
                <li>見出し、写真、体裁を変えての利用はできません。</li>
                <li>人物が特定される写真、動画については肖像権がありますので、本人(または相続人)からの承諾を事前に得ることが必要です。</li>
                <li>その他、デーリー東北新聞社の指示に従います。</li>
              </ol>
            </dd>
            <dt>料金</dt>
            <dd>
              　著作物の二次利用は原則有料です。紙面のコピーや送料なども申請者の負担となります。また記事、写真、動画は提供した時点で利用の有無にかかわらず料金が発生します。
              <Box p={1} textAlign="center">
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">利用者</StyledTableCell>
                        <StyledTableCell align="center">利用目的</StyledTableCell>
                        <StyledTableCell align="center">金　額</StyledTableCell>
                        <StyledTableCell align="center">写真プリント料</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {amountRows.map(row => (
                        <StyledTableRow key={row.user}>
                          <StyledTableCell component="th" scope="row" align="center">{row.user}</StyledTableCell>
                          <StyledTableCell align="center">{row.purpose}</StyledTableCell>
                          <StyledTableCell align="center">{row.amount}</StyledTableCell>
                          <StyledTableCell align="center">{row.printcharge}</StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </dd>
            <dt>無料のケース</dt>
            <dd>
              　次の場合は無料となりますが、申請手続きは必要です。また、写真焼き増しやコピー、送料など実費分は申請者の負担となります。
              <ol>
                <li>ＮＩＥなど学校教育に利用する場合。</li>
                <li>寄稿者本人の自分のホームページ等への掲載。</li>
                <li>申請者が取材を受けた記事の場合。</li>
                <li>その他、当社が認めた場合。</li>
              </ol>
            </dd>
            <dt></dt>
            <dd>
            </dd>
          </dl>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社　読者センター</dt>
            <dd>
              〒031-8601　八戸市城下１−３−１２<br/>
              <PhoneEnabledIcon /> 0178-80-7105<br/>
              <i class="fas fa-fax mx-1"></i> 0178-71-1450<br/>
            </dd>
          </dl>
        </Box>

      </div>
    </div>
  );
}

export default DailyRight;
